<template>
  <div class="report-wrapper">
    <v-card class="pa-4 mb-6 elevation-2">
<v-row dense>
  <v-col cols="12" md="4">
    <v-checkbox
      v-model="usersSelectAll"
      :indeterminate="selectedUsers.length > 0 && selectedUsers.length < users.length"
      label="Все"
      dense
      hide-details
      class="mb-2"
      @change="toggleSelectAll"
    />

<v-autocomplete
  v-model="selectedUsers"
  :items="users"
  :loading="loadingUsers"
  :search-input.sync="userSearch"
  :filter="userFilter"
  item-text="label"
  item-value="id"
  multiple
  show-select
  outlined dense clearable
  :menu-props="{ maxHeight: '400' }"
  placeholder="Все пользователи"
  hide-details="auto"
  label="Пользователь (можно несколько)"
  @update:search-input="fetchUsers"
>
  <template #selection="{ index }">
    <span
      v-if="!selectedUsers.length && index === 0"
      class="grey--text"
    >
      Все пользователи
    </span>

    <v-chip
      v-else-if="index === 0"
      small
      label
      class="ma-1"
    >
      Выбрано: {{ selectedUsers.length }}
    </v-chip>

  </template>
</v-autocomplete>
  </v-col>
  <v-col cols="12" md="4">
    <label class="filter-label">Дата звонков</label>
    <date-picker
      v-model="callsRange"
      range
      :lang="dpLang"                
      :first-day-of-week="1"        
      type="datetime"
      format="DD.MM.YYYY HH:mm:ss"
      value-type="format"
      :editable="true"
      :time-picker-options="timePickerOpts"
      :default-time="['00:00:00', '23:59:59']"
      input-class="my-date-input"
      @change="fixCallsRange"
    />
  </v-col>

  <v-col cols="12" md="4">
    <label class="filter-label">Дата загрузки</label>
    <date-picker
      v-model="uploadRange"
      range
      type="date"
      :lang="dpLang"
      :first-day-of-week="1"
      format="DD.MM.YYYY"
      value-type="format"
      :editable="true"
      input-class="my-date-input"
    />
  </v-col>

<v-col cols="12" class="d-flex justify-end">
  <v-btn
    color="primary"
    class="mr-3"
    :loading="loading"
    @click="applyFilters"
  >
    Применить
  </v-btn>

  <v-btn
    color="secondary"
    :loading="excelLoading"
    :disabled="!canExportExcel"
    @click="exportExcel"
  >
    Выгрузить в Excel
  </v-btn>
</v-col>
</v-row>

    </v-card>

    <v-data-table
      v-if="filtersApplied"
      dense
      class="elevation-2 report-table"
      :headers="headers"
      :items="items"
      :options.sync="options"
      :loading="loading"
      :footer-props="{ 'items-per-page-options':[1000] }"
    >
      <template #loading>
        <v-progress-linear indeterminate color="primary" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import DatePicker        from 'vue2-datepicker'
import ruLocale          from 'vue2-datepicker/locale/ru'
import 'vue2-datepicker/index.css'
import moment from 'moment'
import debounce from 'lodash/debounce'

export default {
  name: 'CallAttemptsReport',
  components: { DatePicker },

  data () {
    const w = px => ({ width: px })

    return {
      dpLang: ruLocale,
      dpColor: '#1976D2',
      users: [],
      selectedUsers: [],
      userSearch: '',
      loadingUsers: false,
      usersSelectAll: false,

      callsRange: [],
      uploadRange: [],

      headers: [
        { text: 'Аккаунт',                    value: 'account',            ...w(110) },
        { text: 'Дата\nзвонков',             value: 'calls_date',         ...w(110) },
        { text: 'Дата\nзагрузки',            value: 'upload_date',        ...w(110) },

        { text: 'Загружено\nконтактов',      value: 'contacts_loaded',    ...w(135) },
        { text: 'Попало\nв обзвоны',         value: 'in_callings',        ...w(120) },
        { text: 'Была ≥1\nпопытка',          value: 'has_any_attempt',    ...w(125) },
        { text: 'Выполнены\nвсе попытки',    value: 'all_attempts_done',  ...w(135) },
        { text: 'Нет попыток\n30 дней',      value: 'no_attempts_30d',    ...w(135) },

        { text: 'Невалидные',                value: 'invalid_numbers',    ...w(110) },
        { text: 'ЧС CRM',                    value: 'blacklist_crmcalls', ...w(95)  },
        { text: 'ЧС аккаунт',                value: 'blacklist_acc',      ...w(105) },

        { text: '1п.-Звонки', value: 'a1_calls', ...w(90)  },
        { text: '1п.-Первый', value: 'a1_first', ...w(130) },
        { text: '1п.-Послед', value: 'a1_last',  ...w(130) },

        { text: '2п.-Звонки', value: 'a2_calls', ...w(90)  },
        { text: '2п.-Первый', value: 'a2_first', ...w(130) },
        { text: '2п.-Послед', value: 'a2_last',  ...w(130) },

        { text: '3п.-Звонки', value: 'a3_calls', ...w(90)  },
        { text: '3п.-Первый', value: 'a3_first', ...w(130) },
        { text: '3п.-Послед', value: 'a3_last',  ...w(130) },

        { text: '4п.-Звонки', value: 'a4_calls', ...w(90)  },
        { text: '4п.-Первый', value: 'a4_first', ...w(130) },
        { text: '4п.-Послед', value: 'a4_last',  ...w(130) }
      ],
      items: [],
      options: {},

      filtersApplied: false,
      loading: false,
      excelLoading: false,

      timePickerOpts: {
        start: '00:00:00',
        step: '00:01:00',
        end:  '23:59:59',
        format: 'HH:mm:ss'
      }
    }
  },

  computed: {
    canExportExcel () {
      const callsOk  = Array.isArray(this.callsRange)  && this.callsRange.length  === 2
      const uploadOk = Array.isArray(this.uploadRange) && this.uploadRange.length === 2
      return callsOk && uploadOk && !this.excelLoading
    }
  },

  methods: {
    toggleSelectAll (val) {
      this.selectedUsers = val ? this.users.map(u => u.id) : []
    },

    userFilter (item, q, itemTxt) {
      return (itemTxt || '')
        .toString().toLowerCase()
        .includes((q || '').toString().toLowerCase())
    },

    async fetchUsers (search = '') {
      if (!this._debouncedFetch) {
        this._debouncedFetch = debounce(this._fetchUsers, 350)
      }
      this._debouncedFetch(search)
    },

    async _fetchUsers (search) {
      this.loadingUsers = true
      try {
        const { data } = await this.$http.axios.get('/admin_users/users', {
          params: {
            search,
            calls_from: this.callsRange?.[0] || null,
            calls_to:   this.callsRange?.[1] || null
          }
        })
        this.users = data.map(u => ({ id: u, label: u }))
      } catch (e) {
        console.error('Не удалось получить пользователей', e)
      } finally {
        this.loadingUsers = false
      }
    },

    fixCallsRange (val) {
      if (Array.isArray(val) && val.length === 2 && val[1]) {
        const [dateStr, timeStr] = val[1].split(' ')
        if (timeStr === '00:00:00') {
          this.$set(this.callsRange, 1, `${dateStr} 23:59:59`)
        }
      }
    },

    async applyFilters () {
      if (!this.callsRange.length || !this.uploadRange.length) return

      this.filtersApplied = true
      this.loading = true
      try {
        const payload = {
          users:       this.selectedUsers,
          calls_from:  this.callsRange[0],
          calls_to:    this.callsRange[1],
          upload_from: this.uploadRange[0],
          upload_to:   this.uploadRange[1],
          page:        this.options.page || 1,
          perPage:     this.options.itemsPerPage || 25
        }
        const { data } = await this.$http.axios.post('/report/call-attempts', payload)
        this.items = data.items
        if (data.total) this.options.totalItems = data.total
      } catch (e) {
        console.error('Ошибка загрузки отчёта', e)
        alert('Не удалось загрузить отчёт')
      } finally {
        this.loading = false
      }
    },

    async exportExcel () {
      if (!this.canExportExcel) {
        alert('Сначала выберите диапазоны дат «Звонков» и «Загрузки»')
        return
      }

      this.excelLoading = true
      try {
        const payload = {
          users:       this.selectedUsers,
          calls_from:  this.callsRange[0],
          calls_to:    this.callsRange[1],
          upload_from: this.uploadRange[0],
          upload_to:   this.uploadRange[1]
        }
        const { data } = await this.$http.axios.post('/report/call-attempts/excel', payload, {
          responseType: 'blob'
        })

        const blob = new Blob([data])
        const url  = URL.createObjectURL(blob)
        const link = Object.assign(document.createElement('a'), {
          href: url,
          download: `call_attempts_${moment().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`
        })
        document.body.appendChild(link)
        link.click()
        link.remove()
        URL.revokeObjectURL(url)
      } catch (e) {
        console.error('Ошибка Excel', e)
        alert('Не удалось скачать Excel')
      } finally {
        this.excelLoading = false
      }
    }
  },

  watch: {
    options: {
      deep: true,
      handler (n, o) {
        const needReload = ['page', 'itemsPerPage']
          .some(k => n[k] !== o[k])
        if (needReload && this.filtersApplied) this.applyFilters()
      }
    },

    callsRange (val) {
      if (Array.isArray(val) && val[0] && val[1]) {
        this.fetchUsers(this.userSearch || '')
      }
    },

    selectedUsers (val) {
      this.usersSelectAll = val.length && val.length === this.users.length
    },

    users (val) {
      if (this.usersSelectAll) {
        this.selectedUsers = val.map(u => u.id)
      }
    }
  },

  mounted () {
    this.fetchUsers()
  }
}
</script>

<style scoped>
.filter-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
  display: inline-block;
}

.my-date-input {
  width: 100%;
}

.report-wrapper {
  overflow-x: auto;
}
::v-deep(.mx-datepicker) {
  font-family: 'Roboto', sans-serif;
}

::v-deep(.mx-calendar)       { border-radius: 8px; }
::v-deep(.mx-calendar-panel) { border: none;       }
.report-table ::v-deep th,
.report-table ::v-deep td {
  white-space: nowrap;
  font-size: 12px;
  padding: 4px 8px;
}

.report-table ::v-deep th {
  line-height: 1.25;
  font-weight: 600;
}
</style>
